import React from "react";

export default function ContentDeniedMessage() {
  return (
    <div className="alert alert-danger" role="alert">
      Parece que no tienes acceso para entrar a esta página.
    </div>
  );
}
